import { cookies } from '../cookies'
import { languageBrowser } from '../languageBrowser'

const FIELD_NAME = 'i18n_language'

export function localeGet(): string {
  return cookies.get(FIELD_NAME) || languageBrowser()
}
